interface BalanceTooltipProps {
  active?: boolean;
  payload?: Array<{ payload: { month: string; balance: number } }>;
}

const formatMoney = (n: number): string =>
  n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Shared hover readout for the account balance curves.
// Shows the recorded date and the balance carried at that point.
function BalanceTooltip({ active, payload }: BalanceTooltipProps) {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const point = payload[0].payload;

  return (
    <div className="pointer-events-none rounded-md border border-background-300 bg-background-50 px-3 py-2">
      <p className="font-data text-[10px] tracking-[0.16em] text-foreground-500 uppercase">
        {point.month}
      </p>
      <p className="mt-1 font-data text-[13px] font-semibold text-foreground-950 whitespace-nowrap">
        {formatMoney(point.balance)}
      </p>
    </div>
  );
}

export default BalanceTooltip;